import { useNavigate } from 'react-router-dom'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { usePayrollResults } from 'modules/payroll_bundle/lib/PayrollResultContext'
import { UPDATE_DATA } from 'modules/payroll_bundle/lib/constants'
import { resultConceptsLabels } from 'modules/payroll_bundle/lib/constants'
import { usePolicyPeriods } from 'modules/payroll_bundle/lib/policyPeriodsContext'

interface EmptyListItemProps {
  hasOtherPayment: boolean
}

const EmptyListItem = ({ hasOtherPayment }: EmptyListItemProps) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const titleText = resultConceptsLabels()['regular_payroll']
  const { policyId, currentPeriod, currentPeriodStatus } = usePolicyPeriods()
  const { resultDispatch } = usePayrollResults()

  const resultPath =
    policyId && currentPeriod?.id
      ? navigation.payrollBundle.policy.period.cycles.results.fullPath({
          policyId,
          periodId: currentPeriod?.id,
        })
      : navigation.payrollBundle.results.fullPath()

  const openResultImport = () => {
    navigate(resultPath)
    resultDispatch({
      type: UPDATE_DATA,
      payload: {
        showUploadModal: true,
      },
    })
    track(trackingEvents.payroll.importResult, {
      period_status: currentPeriodStatus,
    })
  }

  return (
    <Box
      height="s64"
      padding="s16"
      border={
        hasOtherPayment
          ? {
              bottom: { width: 's1', style: 'solid', color: 'grey400' },
            }
          : {
              top: undefined,
            }
      }
      justifyContent="center"
      cursor="pointer"
      onClick={openResultImport}
    >
      <Box alignItems="center" justifyContent="spaceBetween" width="full" flexDirection="row">
        <Box minWidth="fit-content" width="s200">
          <Text.Normal size="300" weight="medium">
            {titleText}
          </Text.Normal>
        </Box>
        <Box alignItems="center" justifyContent="spaceBetween" width="full" flexDirection="row">
          <Text.Normal size="300">
            {i18n.t('payroll_bundle.payroll_dashboard.payment_summary.empty_regular_payroll')}
          </Text.Normal>
          <Box flexDirection="row" alignItems="center" gap="s40">
            <Box width="fit-content">
              <Button onClick={openResultImport} type="secondary" iconName="arrow-right" />
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default EmptyListItem
